import React from 'react'
import styles from './styles.css'
import moment from 'moment'

export default function System({message}) {
  const getTimeFormat = () => {
    if (moment(message.date).isBefore(moment().startOf('year'))) {
      return 'DD/MM/YYYY HH:mm'
    }
    if (moment(message.date).isBefore(moment().startOf('day'))) {
      return 'DD/MM HH:mm'
    }

    return 'HH:mm'
  }
  return (
    <div className={styles.container}>
      {message.text} {moment(message.date).format(getTimeFormat())}
    </div>
  )
}
